import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class DoubleImg {
  constructor(el) {
    this.el = el
    this.title = this.el.querySelector('.double-img--title')
    this.text = this.el.querySelector('.double-img--text')
    this.init()
  }

  init() {
    this.imgAnimation()

    if (this.title) this.revealAnimation(this.title)
    if (this.text) this.revealAnimationSimple(this.text)
  }

  imgAnimation() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches

    const map = {
      '.double-img--right': isMobile ? 8 : 35,
    }

    Object.entries(map).forEach(([selector, yVal]) => {
      const img = this.el.querySelector(selector)
      if (!img) return

      gsap.fromTo(
        img,
        {
          y: 0,
        },
        {
          y: -yVal,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: img,
            scrub: 1,
          },
        }
      )
    })
  }

  revealAnimation(target) {
    const split = new SplitText(target, {
      type: 'words',
      mask: 'lines',
    })

    gsap.set(split.words, {
      y: 24,
      opacity: 0,
    })

    gsap.to(split.words, {
      y: 0,
      opacity: 1,
      stagger: 0.07,
      ease: 'power3.out',
      duration: 1,
      scrollTrigger: {
        trigger: target,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }

  // apparition en un seul bloc (pas de SplitText), plus rapide que le reveal mot par mot
  revealAnimationSimple(target) {
    gsap.set(target, {
      y: 16,
      opacity: 0,
    })

    gsap.to(target, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: target,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  }
}